module.exports = __webpack_public_path__ + "img/502.b645de00.jpg";